import { render } from "./CmpPreviewMockupWhatsapp.vue?vue&type=template&id=510b3541&scoped=true"
import script from "./CmpPreviewMockupWhatsapp.vue?vue&type=script&lang=js"
export * from "./CmpPreviewMockupWhatsapp.vue?vue&type=script&lang=js"

import "./CmpPreviewMockupWhatsapp.vue?vue&type=style&index=0&id=510b3541&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510b3541"]])

export default __exports__